
import { supabase } from '@/integrations/supabase/client';

// Get all unique product names
export const getProducts = async () => {
  // First try to get products from the products table
  const { data: productsData, error: productsError } = await supabase
    .from('products')
    .select('name');

  if (productsError) {
    console.error("Error fetching products:", productsError);
    // Fallback to getting products from farms table if needed
    const { data: farmsData, error: farmsError } = await supabase
      .from('farms')
      .select('product_name')
      .not('product_name', 'is', null);
    
    if (farmsError) throw farmsError;
    
    // Get unique product names and filter out null values
    const uniqueProducts = [...new Set(farmsData.map(row => row.product_name).filter(Boolean))];
    return uniqueProducts;
  }

  // Return product names from products table
  return productsData.map(row => row.name);
};

// Get all products with their categories
export const getProductsWithCategories = async () => {
  const { data, error } = await supabase
    .from('products')
    .select(`
      id,
      name,
      description,
      unit_of_measure,
      categories(name)
    `);
  
  if (error) throw error;
  return data;
};
